import { getEventsPlaceStatus, getLocalStatus, Status } from '@model/show-activity-room';
import type { NextRouter } from 'next/router';
import urlParse from 'url-parse';
import refreshTokenOrGetCorpInfo, {
  ResfreshTokenRes,
  userInfoStorage,
  LOGINSTATUS,
} from '../model/refresh-token';
import addURLSearch from './add-url-search';
import deleteURLSearch from './delete-url-search';
import { getRequest } from './get-url-request';
import { isMeetingApp, isMobile } from './ua/is-mobile';
import { isWechat } from '@tencent/web-base';
// import isProDomain from './env/is-prod-domain';
export type UserStatus = Status;

interface ReqParams {
  login_type: number;
  sync_to_meeting?: boolean;
  from_source?: string;
  extra_params?: string;
  /**
   * 嘉宾链接唯一标识
   */
  uid?: string;
}

export const goLogin = (loginType = 0, extraUrlParams = {}) => {
  const uid = getRequest('uid', location.href) || '';
  const params: ReqParams = {
    login_type: loginType,
    uid,
  };
  if (extraUrlParams) {
    Object.assign(params, extraUrlParams);
  }

  const redirectUrl = getRedirectPathUrl();
  console.log('goLogin getRedirectPathUrl', redirectUrl);

  if (isWechat(navigator.userAgent)) {
    // 微信浏览器
    const url = addURLSearch(`${window.location.origin}/v2/login/wechat`, {
      // m_login_source_id: 2, // 业务方来源 id; 1 - 直播, 2 - 详情页
      redirect_link: encodeURIComponent(addURLSearch(redirectUrl, { ...params })),
      // voov 跳转
      pagetype: 3,
    });

    window.location.replace(url);
  } else if (isMobile()) {
    const url = addURLSearch(`${window.location.origin}/mobile/login.html`, {
      redirect_link: encodeURIComponent(addURLSearch(redirectUrl, { ...params })),
      // voov 跳转
      pagetype: 3,
    });
    // window.location.replace(url);
    window.location.href = url;
  } else {
    // PC 端
    const url = addURLSearch(`${window.location.origin}/qrcode-login.html`, {
      redirect_type: 2,
      // m_login_source_id: 2, // 业务方来源 id; 1 - 直播, 2 - 详情页
      redirect_link: encodeURIComponent(addURLSearch(redirectUrl, { ...params })),
      // voov 跳转
      pagetype: 3,
    });
    window.location.href = url;
  }
};
export const getUserInfoFromSession: any = () => {
  if (userInfoStorage?.loginRomateStatus === LOGINSTATUS?.LOADING) {
    return setTimeout(() => getUserInfoFromSession(), 50);
  }
  return userInfoStorage?.userInfo;
};
export const getRedirectPathUrl = () => {
  const pathname = location.pathname
    ? location.pathname.substring(1, location.pathname.length)
    : '';
  if (pathname.indexOf('middle-login') !== -1) {
    return decodeURIComponent(getRequest('redirect_link', window.location.href) || '');
  }
  let search = deleteURLSearch(window.location.search, 'redirect_link');
  search = deleteURLSearch(search, 'redirect_type');
  return pathname + search;
};

export interface UserData {
  app_id: string;
  userid: string;
  crop_id: string;
  app_uid: string;
  nick_name: string;
  avatar: string;
  corp_type?: number | string | undefined;
  corp_name?: string;
  phone?: string;
  user_type?: string;
  account_corp_id?: string;
}

export const shouldGotoLaunchApp = () =>
  isMobile() && !isMeetingApp() && !userInfoStorage?.userInfo?.userid;

export const navigateToLaunchIfNeed = (
  router: NextRouter,
  extraParams: Record<string, any> = {},
) => {
  if (shouldGotoLaunchApp()) {
    const to = urlParse(window.location.href);
    const toQuery = Object.assign(urlParse.qs.parse(to.query), extraParams);
    to.set('query', urlParse.qs.stringify(toQuery));
    router.push({ pathname: '/app-launch', query: { scheme_url: to.toString() } });
    return true;
  }
  return false;
};

export const checkLogin = async () => {
  const info = await getInfo();
  if (!info?.isLogin) {
    localStorage.setItem(`${location.origin}:loginState`, '0');
    return false;
  }
  localStorage.setItem(`${location.origin}:loginState`, '1');
  return true;
};

const getInfo = async (ctx?: any) => {
  const isDefaultLogin = !!getUserInfoFromSession()?.userid;
  if (isDefaultLogin) return userInfoStorage;
  const res = await refreshTokenOrGetCorpInfo(ctx);
  // 用户被封禁用
  if (res?.code === -20016) {
    goLogin();
  }
  return userInfoStorage;
};

export interface UserDataObject {
  isLogin: boolean;
  userStatus: Status;
  userInfo: ResfreshTokenRes['data'];
}

// 根据当前登录状态获取用户权限
export const loginCheckUser = async (cookies: any, ctx?: any) => {
  const userData: UserDataObject = {
    isLogin: false,
    // @ts-ignore
    userStatus: {
      is_show_activity_room: undefined,
      is_host: undefined,
      is_beta_user: undefined,
      has_payment_qualification: undefined,
      gray_switch: undefined,
    },
    userInfo: {
      app_id: '',
      userid: '',
      nick_name: '',
      avatar: '',
      avatar_type: '',
      area: '',
      phone: '',
      email: '',
      name: '',
      gender: '',
      postion: '',
      department: '',
      user_type: '',
      corp_id: '',
      corp_name: '',
      login_tag: '',
      user_district: '',
      role_id: '',
      corp_type: '',
    },
  };
  // 当前处于客户端渲染时
  if (!ctx) {
    const info = await getInfo();
    userData.isLogin = info?.isLogin;
    userData.userInfo = info?.userInfo as ResfreshTokenRes['data'];
    if (userData?.isLogin) {
      const status = await getLocalStatus();
      userData.userStatus = status;
    }
  }
  // 判断当前是否需要跟cookie重新获取
  try {
    if (cookies?.we_meet_token && !userData?.isLogin) {
      const res = await refreshTokenOrGetCorpInfo(ctx);
      if (res?.code === 0) {
        userData.userInfo = res?.data as ResfreshTokenRes['data'];
        userData.isLogin = true;
      } else {
        userData.isLogin = false;
      }
    }
    if (userData?.isLogin && !userData?.userStatus?.is_show_activity_room) {
      const data = await getEventsPlaceStatus(ctx);
      userData.userStatus = data;
    }
  } catch (error) {
    console.log('catch error', error);
    // userData?.userStatus =
  }

  return userData;
};
